var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrderGuide = function SvgOrderGuide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 1 3.553 7.241L24 9.41l-5.75 5.633 1.357 7.959-7.107-3.76-7.107 3.76 1.357-7.959L1 9.41 8.947 8.24 12.5 1Z",
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#363840",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M9.699 12.1H16.5M9.699 15.402H14.3"
  })));
};
export default SvgOrderGuide;